import React from 'react';
import { brandLogos } from '../mock';
import useReveal from '../hooks/useReveal';

const Brands = () => {
  useReveal();
  const loop = [...brandLogos, ...brandLogos];
  return (
    <section id="brands" className="py-16 lg:py-24 bg-[#F7F4EA]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
            Trusted Partners
          </div>
          <h2 className="h-display uppercase text-[40px] md:text-[64px] text-[#1a1410]">
            Our <span className="text-[#F58220]">Brands</span>
          </h2>
          <p className="mt-5 text-[15px] text-[#4D4D4D] max-w-[640px] mx-auto">
            We partner with the world’s most loved appliance makers — ensuring
            authenticity, warranty and post-sale support on every purchase.
          </p>
        </div>
      </div>

      <div className="reveal marquee-pause overflow-hidden border-y border-[#E9D6C1] py-10 bg-white">
        <div className="marquee gap-16 px-8">
          {loop.map((b, i) => (
            <div
              key={`${b.name}-${i}`}
              className="flex-shrink-0 px-8 py-3 flex items-center justify-center grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-500"
            >
              <span className="h-display text-[28px] md:text-[32px] tracking-wider text-[#1a1410] whitespace-nowrap uppercase">
                {b.text}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16 grid sm:grid-cols-3 gap-6">
        {[
          { k: '15+', l: 'Premium Brands' },
          { k: '25+', l: 'Years of Trust' },
          { k: '24/7', l: 'Customer Support' },
        ].map((s, i) => (
          <div
            key={s.l}
            className="reveal bg-white border border-[#E9D6C1] rounded-2xl p-8 text-center card-lift"
            style={{ transitionDelay: `${i * 100}ms` }}
          >
            <div className="h-display text-[44px] text-[#1a1410]">{s.k}</div>
            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#4D4D4D] mt-2">
              {s.l}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Brands;
